import { supabase } from './supabase';
import { PostgrestError } from '@supabase/supabase-js';

export interface Review {
  id: string;
  reviewer_id: string;
  reviewer: {
    display_name?: string;
    full_name?: string;
    avatar_url?: string;
  };
  reviewed_user_id: string;
  rating: number;
  comment: string;
  created_at: string;
  helpful_count: number;
  response?: {
    response: string;
    created_at: string;
  };
}

export async function getReviews(userId: string): Promise<{ reviews: Review[]; error: PostgrestError | null }> {
  const { data, error } = await supabase
    .from('reviews')
    .select('*, reviewer:reviewer_info!reviewer_id(*), helpful_votes:review_helpful_votes(count), response:review_responses(response, created_at)')
    .eq('reviewed_user_id', userId)
    .order('created_at', { ascending: false });

  if (error) return { reviews: [], error };

  const reviews = data.map(review => ({
    ...review,
    helpful_count: review.helpful_votes[0]?.count || 0,
    response: review.response[0] || null
  }));

  return { reviews, error: null };
}

export async function createReview(
  userId: string,
  rating: number,
  comment: string
): Promise<{ review: Review | null; error: PostgrestError | null }> {
  console.log('Creating review:', { userId, rating, comment });
  
  // Get the current user's ID
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) {
    console.error('No authenticated user found when creating review');
    return { review: null, error: { message: 'Not authenticated' } as PostgrestError };
  }
  
  console.log('Current user ID:', user.id);
  
  const { data, error } = await supabase
    .from('reviews')
    .insert({
      reviewer_id: user.id,     // Add the reviewer_id field
      reviewed_user_id: userId,
      rating,
      comment,
    })
    .select('*, reviewer:reviewer_info!reviewer_id(*)')
    .single();

  if (error) {
    console.error('Error creating review:', error);
  } else {
    console.log('Review created successfully:', data);
  }

  return { review: data, error };
}

export async function markReviewHelpful(
  reviewId: string
): Promise<{ error: PostgrestError | null }> {
  const { error } = await supabase
    .from('review_helpful_votes')
    .insert({ review_id: reviewId });

  return { error };
}

export async function reportReview(
  reviewId: string,
  reason: string
): Promise<{ error: PostgrestError | null }> {
  const { error } = await supabase
    .from('review_reports')
    .insert({
      review_id: reviewId,
      reason
    });

  return { error };
}